import { ToastProvider } from './toast';
import { PublicShowGlowProvider } from './public-circular-glow';
import { CurrentThemeProvider } from './current-theme';
import { AuthProvider } from './auth';
import { AccountPreferencesProvider } from './accountPreferences';
import { GlobalStyle } from '../styles/global';
import { IFCWithChildren } from '../interfaces/IFCWithChildren';

export const ProvidersHOC: IFCWithChildren = ({ children }) => (
  <CurrentThemeProvider>
    <GlobalStyle />
    <ToastProvider>
      <PublicShowGlowProvider>
        <AuthProvider>
          <AccountPreferencesProvider>{children}</AccountPreferencesProvider>
        </AuthProvider>
      </PublicShowGlowProvider>
    </ToastProvider>
  </CurrentThemeProvider>
);
